import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import Program_6 from '../assets/Program_6.jpg';
import Header from "../components/Header";
import Footer from '../components/Footer';
import photo_1 from '../assets/photo_1.jpg';
import Program_11 from '../assets/Program_11.jpg';
import Program2 from '../assets/Program_2.jpg';
import photo_10 from  '../assets/photo_10.jpg';
import photo from '../assets/photo.jpg';


const programs = [
  {
    title: 'Educational Support Programs',
    description:
      'Enhancing educational opportunities through free classes and learning resources.',
    image: Program_6,
  },
  {
    title: "Improving Quality of Life",
    description: "Integrated Development Project on Health, Education, HIV, WaSH; Income Generation Program; women empowerment; IEC",
    image: photo_1,
  },
  {
    title: "Organising Outreach Camps to serve the people living in rural/tribal hard to reach areas.",
    description: "In outreach areas of the district of Barmer. The project was supported by District Health Society, Barmer, GoR.",
    image: Program2,
  },
  {
    title: "Migration Information Centre (MIC) for HIV/AIDS Prevention… as “Empowering Adolescents Boys and Girls on their Rights and Choices",
    description: "Control supported by Mainstreaming Resource Unit under Rajasthan State AIDS Control Society, GoR and Jindal Group of Companies.",
    image: Program_11,
  },
  {
    title: "Empowering women from economically weaker sections through skills development, job opportunities and business education",
    description: "Empowering women from economically weaker sections of Rajasthan through job opportunities and business education.",
    image: photo_10,
  },
  {
    title: "We aim to enhance the health and well-being of mothers and newborns through accessible healthcare, education, and support services",
    description: "Project Nurture aims to enhance the health and well-being of mothers and newborns through accessible healthcare, education, and support services.",
    image: photo,
  }
];

export default function Programs() {
  return (
    <div>
      <Header />
      
      <Card sx={{ px: 6, py: 6, maxWidth: '1200px', margin: '0 auto' }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Our Programs
          </Typography>
          <Typography variant="body1">
            Discover the impactful initiatives Samriddhi Trust is implementing in underprivileged areas to foster growth and development.
          </Typography>
        </Box>

        {/* Program Cards */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 3,
            justifyContent: 'space-between',
          }}
        >
          {programs.map((program, index) => (
            <Card
              key={index}
              sx={{
                flex: '1 1 calc(50% - 24px)', // Two cards per row with gap
                display: 'flex',
                flexDirection: 'column',
                minWidth: 275,
                maxWidth: '100%',
              }}
            >
              {program.image && (
                <CardMedia
                  component="img"
                  height="300"
                  image={program.image}
                  alt={program.title}
                />
              )}
              <CardContent>
                <Typography variant="h6" fontWeight="bold">
                  {program.title || program.tiele}
                </Typography>
                <Typography variant="body2" sx={{ my: 1 }}>
                  {program.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Card>

      <Footer />
    </div>
  );
} 
